import { collection, deleteDoc, doc, getFirestore, onSnapshot } from "@firebase/firestore";
import { getFunctions, httpsCallable } from "@firebase/functions";
import { useEffect, useState } from "react";
import app from "../firebase";

export type UserMessageInfo = {
  author: {
    name: string;
    email: string;
  };
  message: {
    subject: string;
    body: string;
  };
};

export const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export async function sendUserMessage(msg: UserMessageInfo) {
  if (!msg.author.email.match(emailRegex)) {
    throw new Error('invalid-email');
  }
  const res = await httpsCallable(getFunctions(app), 'recordUserMessage')(msg);
  return (res.data as any).msgId as string;
}

export async function deleteUserMessage(id: string) {
  return deleteDoc(doc(getFirestore(app), `/messages/${ id }`));
}

export function useUserMessages(): (UserMessageInfo & { id: string; })[] {
  const [ messages, setMessages ] = useState<(UserMessageInfo & { id: string; })[]>([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(getFirestore(app), '/messages'), (newCollection) => {
      setMessages(newCollection.docs.map((d) => {
        return { ...(d.data() as UserMessageInfo), id: d.id };
      }));
    });

    return () => unsub();
  }, []);

  return messages;
}
